import { createApp } from 'vue'
import App from './App.vue'
import Icon from './components/common/Icon.vue'
import router from './router'
import './assets/scss/fonts.scss'
import './assets/scss/style.scss'
import './assets/scss/helper.scss'
import './assets/scss/media.scss'
import './assets/scss/animation.scss'

const app = createApp(App);
app.component('icon', Icon);
app.use(router)
app.mount('#app')
